import React, { memo } from 'react';
import { connect } from 'react-redux';

import { SIDEBAR_STATE } from '../../../../sidebar/constants';
import type { AppState } from '../../../../../reducers';

import * as S from './styles';

type Props = {
  className?: string;
  children: React.ReactNode;
  colors?: {
    bg: string;
    text: string;
    link: string;
  };
  sidebarOpen: boolean;
};

const Slice = ({
  className,
  children,
  colors = { bg: 'inherit', text: 'inherit', link: 'inherit' },
  sidebarOpen,
}: Props) => {
  return (
    <S.Slice
      className={className}
      sidebarOpen={sidebarOpen}
      backgroundColor={colors.bg}
      textColor={colors.text}
      linkColor={colors.link}
    >
      <S.SliceContent sidebarOpen={sidebarOpen}>{children}</S.SliceContent>
    </S.Slice>
  );
};

const mapStateToProps = (state: AppState) => ({
  sidebarOpen: state.areas.sidebar.tab !== SIDEBAR_STATE.NONE,
});

export default connect(mapStateToProps, {})(memo(Slice));
